import { Splide } from '@splidejs/splide';
import { init } from 'shareon';

init();

if (document.querySelector('.rcreviews--section')) {
    new Splide('.rcreviews--section', {
        perPage: 2,
        perMove: 1,
        rewind: true,
        gap: '32px',
        pagination: false,
        autoplay: true,
        interval: 3000,
        breakpoints: {
            1151: {
                perPage: 1,
            },
        },
        classes: {
            prev: 'splide__arrow--prev rcreviews-prev',
            next: 'splide__arrow--next rcreviews-next',
        },
    }).mount();
}

if (document.querySelector('.suburbs--section')) {
    new Splide('.suburbs--section', {
        perPage: 4,
        perMove: 1,
        rewind: true,
        gap: '32px',
        pagination: false,
        autoplay: true,
        interval: 3000,
        breakpoints: {
            1151: {
                perPage: 1,
            },
        },
        classes: {
            prev: 'splide__arrow--prev suburbs-prev',
            next: 'splide__arrow--next suburbs-next',
        },
    }).mount();
}

if (document.querySelector('.teams--section')) {
    new Splide('.teams--section', {
        perPage: 3,
        perMove: 1,
        rewind: true,
        gap: '64px',
        pagination: false,
        autoplay: true,
        interval: 3000,
        breakpoints: {
            1151: {
                perPage: 2,
            },
            767: {
                perPage: 1,
            },
        },
        classes: {
            prev: 'splide__arrow--prev teams-prev',
            next: 'splide__arrow--next teams-next',
        },
    }).mount();
}

window.addEventListener('DOMContentLoaded', () => {
    const buttonGroups = [
        ['rcreviews-btn-prev', 'rcreviews-prev'],
        ['rcreviews-btn-next', 'rcreviews-next'],
        ['suburbs-btn-prev', 'suburbs-prev'],
        ['suburbs-btn-next', 'suburbs-next'],
        ['teams-btn-prev', 'teams-prev'],
        ['teams-btn-next', 'teams-next'],
    ];

    buttonGroups.forEach(([sourceClass, targetClass]) => {
        document.querySelectorAll(`.${sourceClass}`).forEach((button) => {
            button.addEventListener('click', () => {
                document.querySelector(`.${targetClass}`)?.click();
            });
        });
    });
});
